import React from 'react';

export const CloseIcon = ({ size, stroke }: { size?: string; stroke?: string }) => (
  <svg width={size || "20"} height={size || "21"} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.0106 5.39317L4.61916 15.7846M14.9921 15.8782L4.61931 5.50545" stroke={stroke || "white"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
